import React from "react";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { FaRegUser } from "react-icons/fa";

import HeaderPopup from "./header-popup/HeaderPopup";
import LoggedInDropdown from "./loggedIn-dropdown/LoggedInDropdown";
import SearchBar from "./search-bar/SearchBar";
import HeaderLogo from "./header-logo/HeaderLogo";
import { decodeWithSalt } from "../../utils/encodeFunctions";
import "./header.css";

function Header() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const [searchParams] = useSearchParams();

  const categoryType      = searchParams.get("categoryType") || "";
  const searchedLocation  = searchParams.get("location") || "";

  const searchBarPaths = ["/", "/ads"];
  const isLoggedIn = decodeWithSalt(sessionStorage.getItem("loggedIn") ?? "");

  const handleSearch = (query: string) => {
    const params = new URLSearchParams(location.search);
    params.set("page", "1");
    params.set("searchTerm", query.replaceAll(" ", "+"));
    if (categoryType)     { params.set("categoryType", categoryType); }
    else                  { params.delete("categoryType"); }
    if (searchedLocation) { params.set("location", searchedLocation); }
    else                  { params.delete("location"); }
    navigate(`/ads?${params.toString()}`);
  };

  return (
    <header className="site-header">
      {/* ── Main bar ─────────────────────────────────── */}
      <div className="site-header__bar">
        <div className="d-flex justify-content-between align-items-center maximum-width mx-auto px-3">

          {/* Left: hamburger (mobile) | logo + nav (desktop) */}
          <div className="d-flex align-items-center gap-2 gap-md-3">
            <div className="d-block d-md-none">
              <HeaderPopup />
            </div>
            <div className="d-none d-md-block">
              <HeaderLogo />
            </div>
            <nav className="d-none d-md-flex align-items-center gap-1 ms-1">
              {location.pathname !== "/" && (
                <Link to="/" className="header-nav-link">Home</Link>
              )}
              {location.pathname !== "/ads" && (
                <Link to="/ads?page=1" className="header-nav-link">All Ads</Link>
              )}
              <Link to="/about-us" className="header-nav-link">About Us</Link>
            </nav>
          </div>

          {/* Right: post ad + auth */}
          <div className="d-flex align-items-center gap-2">
            <Link to="/create-ad" className="btn header-post-btn d-none d-sm-inline-block">
              + Post Free Ad
            </Link>
            {isLoggedIn ? (
              <LoggedInDropdown />
            ) : (
              <Link to="/login" className="btn btn-outline-light btn-sm">
                Sign In
              </Link>
            )}
          </div>
        </div>
      </div>

      {/* ── Search bar (home + listing pages only) ───── */}
      {searchBarPaths.includes(location.pathname) && (
        <div className="site-header__search">
          <div className="maximum-width mx-auto px-3 px-md-4">
            <SearchBar
              placeholder="Search by make, model, location..."
              onSearch={handleSearch}
              paddingClass=""
              fontSizeClass=""
            />
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
